import { Link, Typography } from '@la/ds-ui-components';
import { getSiteId, useAppSelector } from '@la/services';
import { Activity, Program } from '@la/types';
import { useGetLocationsQuery } from 'redux/services/activity';
import styles from './SingleActivityViewLocation.module.scss';

type SingleActivityViewLocationProps = {
  activity?: Activity;
  program?: Program;
};
export default function SingleActivityViewLocation({
  activity,
  program,
}: SingleActivityViewLocationProps) {
  const siteId = useAppSelector(getSiteId);
  const { data: locations } = useGetLocationsQuery(
    {
      siteId: siteId ?? '',
      programId: program && program.id ? program.id.toString() : '',
    },
    { skip: !program }
  );

  const location = locations?.find(({ id }) => id === activity?.locationId);

  const formatGoogleMapsAddress = () => {
    if (!location?.address) {
      return '';
    }

    const street = location.address.address1?.trim().split(' ').join('+');
    const city = location.address.city?.trim().split(' ').join('+');
    const state = location.address.state?.trim();
    return `https://www.google.com/maps/dir/?api=1&destination=${street}+${city}+${state}`;
  };

  return (
    <>
      {activity?.notes ? (
        <div className={styles.paddingContainer}>
          <Typography variant="ui" size="medium">
            {activity.notes}
          </Typography>
        </div>
      ) : null}

      {location?.address ? (
        <div className={styles.locationContainer}>
          <div>
            <Typography variant="ui" size="large" weight="bold">
              Location
            </Typography>
            <div className={styles.address}>
              <Typography variant="ui" size="large">
                {location.name}
              </Typography>
              <Typography variant="ui" size="large">
                {location.address.address1}
              </Typography>

              {location.address.address2 && (
                <Typography variant="ui" size="large">
                  {location.address.address2}
                </Typography>
              )}
              <Typography
                variant="ui"
                size="large"
              >{`${location.address.city}, ${location.address.state} ${location.address.zipCode}`}</Typography>
            </div>
            <Link href={formatGoogleMapsAddress()} target="_blank">
              Get Directions
            </Link>
          </div>
        </div>
      ) : null}
    </>
  );
}
